export default __webpack_public_path__ + "static/media/about-sec-img.ff8e2e9d.png";